import { useAuthQuery } from "@bn/api";
import { getMyAuthorization } from "@api/v1/methods";

export const useGetMyAuthorization = () =>
  useAuthQuery(["get-my-authorization"], ({ token }) =>
    getMyAuthorization(token)
  );
